export const LANGUAGES = ['BG', 'EN'];
